import utils from "../../services/utils";

export default {
  props: ["data", "quickShop", "borders"],

  data() {
    return {
      trackingInfo: {
        "Brand name": this.data.brand_name,
      },
    };
  },

  methods: {
    openQuickShopModal,
    urlFormatter: utils.urlSafeString,
  },
};

function openQuickShopModal(product) {
  if (this.$session.getAccessToken()) {
    this.$eventBus.$emit("show-quick-shop-modal", product);
  } else {
    this.$eventBus.$emit("show-quick-shop-modal-unregistered", product);
    this.$eventBus.$emit("apply-modal-unregistered", product);
  }
}
